import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import plusButtonImg from '../../images/common/plus.svg';
import minusButtonImg from '../../images/common/minus.svg';
import ColorSF2 from '../../styles/common/ColorSF2';

const BUTTON_SIZE = '53px';
const IMAGE_SIZE = '32px';

const ZoomButton = styled.button`
  width: ${BUTTON_SIZE};
  height: ${BUTTON_SIZE};
  padding: 0;
  border: none;
  background-color: ${ColorSF2.white};
  box-shadow: 4px 4px 4px ${ColorSF2.transparentShadow};
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  z-index: 500;

  border-right: 1px solid ${ColorSF2.lightGray};

  &:hover {
    background-color: ${ColorSF2.mediumGray};
  }

  &:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-right: none;
  }
`;

const ButtonImage = styled.img`
  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE};
`;

/**
 * PDFなどを拡大・縮小するためのボタンのUIコンポーネント
 *
 * ボタンをクリックすると、親コンポーネントによって提供されたコールバック関数が呼び出される
 *
 * @prop {function} onZoomIn - ズームインボタンがクリックされたときに実行されるコールバック関数
 * @prop {function} onZoomOut - ズームアウトボタンがクリックされたときに実行されるコールバック関数
 *
 * @example
 * <ZoomButtons onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} />
 *
 * @returns {ReactElement}
 */
const ZoomButtons = ({ onZoomIn, onZoomOut }) => (
  <>
    <ZoomButton onClick={onZoomIn}>
      <ButtonImage src={plusButtonImg} />
    </ZoomButton>
    <ZoomButton onClick={onZoomOut}>
      <ButtonImage src={minusButtonImg} />
    </ZoomButton>
  </>
);

ZoomButtons.propTypes = {
  onZoomIn: propTypes.func.isRequired,
  onZoomOut: propTypes.func.isRequired,
};

export default ZoomButtons;
